import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import styles from "./ClientLogos.module.css";
import Spin from "../Spinner/Spinner";
import { API } from "../../config";
import { FaPlus } from "react-icons/fa";
import axios from "axios";

// DnD Kit imports
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { RxDragHandleHorizontal } from "react-icons/rx";
import { CSS } from "@dnd-kit/utilities";
import { toast } from "react-toastify";

function SortableRow({ logo }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: logo._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style} className={styles.clientrow}>
      <td>
        <DragHandle listeners={listeners} attributes={attributes} />
      </td>
      <td>{logo.order_no}</td>
      <td>{logo.company_name}</td>
      <td>
        <img src={logo.logo_url} alt="Logo" className={styles.logos} />
      </td>
      <td>{logo.c_value}</td>
      <td className={styles.edit}>
        <Link to={`/clientlogos/${logo._id}`}>
          <div>Edit</div>
        </Link>
      </td>
    </tr>
  );
}

function ClientLogos() {
  const [companyLogos, setCompanyLogos] = useState([]);
  const [spin, setSpin] = useState(true);
  const [originalOrder, setOriginalOrder] = useState([]);
  const [isChanged, setIsChanged] = useState(false);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    })
  );

  const getData = async () => {
    const data = await fetch(`${API}/companyList`);
    const json = await data.json();
    const companies = (json.companies || []).sort(
      (a, b) => (a.order_no ?? Infinity) - (b.order_no ?? Infinity)
    );
    setCompanyLogos(companies);
    setOriginalOrder(companies.map((c) => c._id));
    setSpin(false);
  };

  const reorderLogos = async (order) => {
    try {
      await axios.put(`${API}/companyList/reorder`, { order });
      await getData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setCompanyLogos((prev) => {
      const oldIndex = prev.findIndex((item) => item._id === active.id);
      const newIndex = prev.findIndex((item) => item._id === over.id);

      const newArray = arrayMove(prev, oldIndex, newIndex);

      newArray.forEach((item, idx) => {
        item.order_no = idx + 1;
      });

      const newOrderIds = newArray.map((c) => c._id);

      setIsChanged(
        JSON.stringify(newOrderIds) !== JSON.stringify(originalOrder)
      );

      return [...newArray];
    });
  };

  const handleSave = async () => {
    const payload = companyLogos.map((item) => ({
      companyId: item._id,
      order: item.order_no,
    }));

    await reorderLogos(payload);
    setOriginalOrder(companyLogos.map((c) => c._id));
    toast.success("Order saved successfully");
    setIsChanged(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {spin ? (
        <Spin />
      ) : (
        <div className={styles.entirepage}>
          <div className={styles.upper}>
            <NavLink to="/">
              <span className={styles.swag}>
                Website
                <span className={styles.greater}> &gt; </span>
              </span>
            </NavLink>
            <span className={styles.req}>Client Logos Home</span>
          </div>
          <div className={styles.heading}>Client Logos Home</div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div className={styles.addingbutton}>
              <Link to="/clientlogos/add">
                <div className={styles.button}>
                  <FaPlus className={styles.addicon} />
                  Add Client Logo
                </div>
              </Link>
            </div>
            <button
              onClick={handleSave}
              disabled={!isChanged}
              className={styles.button}
              style={{ width: "fit-content" }}
            >
              Save Order
            </button>
          </div>
          <div className={styles.logosdisplay}>
            <table className={styles.displaytable}>
              <thead>
                <tr className={styles.clientrowhead}>
                  <th></th>
                  <th>S No.</th>
                  <th>Company Name</th>
                  <th>Logo</th>
                  <th>C value</th>
                  <th></th>
                </tr>
              </thead>
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
              >
                <SortableContext
                  items={companyLogos.map((c) => c._id)}
                  strategy={verticalListSortingStrategy}
                >
                  <tbody>
                    {companyLogos.map((c) => (
                      <SortableRow logo={c} key={c._id} />
                    ))}
                  </tbody>
                </SortableContext>
              </DndContext>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

const DragHandle = ({ listeners, attributes }) => {
  return (
    <span
      {...listeners}
      {...attributes}
      style={{
        cursor: "grab",
        padding: "8px",
        display: "inline-block",
        fontSize: "18px",
        userSelect: "none",
      }}
    >
      <RxDragHandleHorizontal />
    </span>
  );
};

export default ClientLogos;
